import React from 'react';

import { Draggable } from '../DragAndDrop/Draggable';
import { dataHooks } from './constants';

const TOUCH_BACKEND_OPTIONS = {
  delayTouchStart: 200,
  ignoreContextMenu: true,
};

const preventContextMenu = e => e.preventDefault();

export default Component => props => (
  <div data-hook={props.dataHook} onContextMenu={preventContextMenu}>
    <Draggable.Manager
      dataHook={dataHooks.provider}
      backendOptions={TOUCH_BACKEND_OPTIONS}
    >
      <Component {...props} />
    </Draggable.Manager>
  </div>
);
